import NavBar from "./NavBar";
import MyCarousel from "./Carousel";

function Heading() {
    return(
        <div>
          <NavBar 
           />
           <MyCarousel />
          
        </div>

    )
}

export default Heading